import { makeStyles, Theme } from "@material-ui/core/styles";

export const GoalStyles = makeStyles((theme: Theme) => ({
  avatarText: {
    marginRight: "100px",
  },
  root: {
    display: "inline-flex",
  },
  fullWidth: {
    width: "100%",
  },
  goal: {
    background: "#FFF5EA",
    padding: "4px 8px",
    position: "relative",
    borderRadius: 10,
    "&:before": {
      content: "' '",
      borderStyle: "solid",
      borderWidth: "10px 15px 10px 0",
      borderColor: "transparent #FFF5EA transparent transparent",
      position: "absolute",
      left: -7,
      top: -2,
      transform: "rotate(270deg)",
    },
  },
  goalBox: {
    width: "100%",
    padding: "10px 15px",
  },
  title: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 500,
  },
  text: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(16),
    fontWeight: 400,
  },
  edit: {
    cursor: "pointer",
    lineHeight: 1,
    "&:hover": {
      background: "#FFD099",
      borderRadius: "50%",
      boxSizing: "border-box",
      padding: 5,
    },
  },
  avatar: {
    width: 50,
    height: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#E8EAEF",
    [theme.breakpoints.down(768)]: {
      display: "none",
    },
    "& svg": {
      marginInlineEnd: 0,
      marginLeft: 0,
    },
  },
}));
